import styles from './style.module.scss';

interface Props {
    data: any[] | undefined;
};

export default function Expertise(props: Props) {
    const { data } = props;
    const copyOfData = (data && Array.isArray(data)) ? [...data] : null;
    const sortByOrder = copyOfData ? copyOfData.sort((a, b) => a.expert.orderId - b.expert.orderId) : null;

    return (
        <div className={styles.wrapper}>
            {sortByOrder?.map(item => <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>{item.expert.title}</span>
                </div>
                <div className={styles.content_main}>
                    {item.skills.map((skill: any) => <span className={styles.skill}>{skill.title}</span>)}
                </div>
            </div>)}
        </div>
    )
}
